import { ProductEnum } from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                      from '@core/interfaces/route.interface';


export enum TenantConsoleRoutesEnum {
	USAGE_PAGE = 'usage/:product/:usagePeriod',
	SIGNATURES_PAGE = 'signatures',
	STATISTICS_PAGE = 'statistics'
}

export interface TenantConsoleStatisticsPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.TenantConsole;
	path: TenantConsoleRoutesEnum.STATISTICS_PAGE;
}

export interface TenantConsoleTransactionsPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.TenantConsole;
	path: TenantConsoleRoutesEnum.SIGNATURES_PAGE;
}

export interface TenantConsoleUsagePageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.TenantConsole;
	path: TenantConsoleRoutesEnum.USAGE_PAGE;
	params: {
		product: ProductEnum,
		usagePeriod: string
	};
}
